import type { BadgeProps } from './components/base/badge'

export const steppableColors: { [typename: string]: BadgeProps['color'] } = {
  CapacitanceTestStepType: 'green',
  DiodeTestStepType: 'blue',
  HipotTestStepType: 'red',
  LinkTestStepType: 'pink',
  LoadTestStepType: 'violet',
  NoopTestStepType: 'zinc',
  RcdTestStepType: 'cyan',
  ResistanceTestStepType: 'amber',
  ResistanceFourWireTestStepType: 'amber',
  TwistedPairTestStepType: 'orange',
  WireTestStepType: 'purple',
  WireFourWireTestStepType: 'purple',
}
